import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore informative articles about airports and travel facilities on First-Class.com. Find tips, guides, and insights for a smooth airport experience'
          }
        />
        <title>Airport Articles: In-Depth Information and Guides</title>
      </Head>
      <ArticlesList subtype="Articles" type="Airports" />
    </>
  );
}

export default withLayout(Articles, true);
